import React from "react";

const AboutTheMovie = ({ atm }) => {
  return (
    <div className="aboutTheMovie ">
      <h3>About The Movie</h3>
      <p>{atm}</p>
    </div>
  );
};

export default AboutTheMovie;
